import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import Request from "../../components/api/Request";
import { Button } from "devextreme-react/button";
import TextBox from "devextreme-react/text-box";

const TesvikSgkLogin = (props) => {
  const dispatch = useDispatch();

  const popupBasligi = "Login Bilgileri";

  const [loginInfo, setLoginInfo] = useState({yenileEk:""});

  useEffect(() => {
    const request = new Request("/tesvikIslemleri/getGuvenlikKodFile/" + props.data.domainId + "/" + props.data.sistem, "GET");
    request.run().then((response) => {
      if (response.data != null && response.data.data != null) {
        // debugger;
        response.data.data.fileBase64 = "data:image/jpeg;base64," + response.data.data.fileBase64;
        let yenileEk="";
        if(response.data.data.tesvikKanalSayisi && response.data.data.tesvikKanalSayisi >0){
          yenileEk ="("+ response.data.data.tesvikKanalSiradakiLoginOlmamis  + "/"+  response.data.data.tesvikKanalSayisi +")";
        }
        setLoginInfo({
          file: response.data.data.fileBase64,
          name: response.data.data.value,
          domainId: props.data.domainId,
          fileName: response.data.data.fileName,
          yenileEk :yenileEk
        });
      }
    });
  }, []);

  function textValueChanged(data) {
    //loginInfo.name = data.value;
    setLoginInfo(Object.assign({}, loginInfo, { name: data.value }));
    //setLoginInfo(loginInfo);
  }
  function login(domainId) {

    const request = new Request("/tesvikIslemleri/login/" + loginInfo.domainId + "/" + loginInfo.name + "/" + props.data.sistem + "/" + loginInfo.fileName, "GET");
    request.run().then((response) => {

      if (response && response.data && response.data.data === true) {
        props.hide();
      } else {
        refreshLoginImage();
      }
    });
  }
  function refreshLoginImage() {
    let domainId = loginInfo.domainId;
    const request = new Request("/tesvikIslemleri/reloadGuvenlikKodFile/" + domainId + "/" + props.data.sistem, "GET");
    request.run().then((response) => {
      if (response.data != null && response.data.data != null) {
        response.data.data.fileBase64 = "data:image/jpeg;base64," + response.data.data.fileBase64;
        let yenileEk="";
        if(response.data.data.tesvikKanalSayisi && response.data.data.tesvikKanalSayisi >0){
          yenileEk ="("+ response.data.data.tesvikKanalSiradakiLoginOlmamis  + "/"+  response.data.data.tesvikKanalSayisi +")";
        }
        setLoginInfo({
          file: response.data.data.fileBase64,
          name: response.data.data.value,
          domainId: props.data.domainId,
          fileName: response.data.data.fileName,
          yenileEk :yenileEk
        });
      }
    });
  }

  return (
    <React.Fragment>
      <img src={loginInfo.file} />
      <br></br>
      <Button
        id="refreshButton"
        icon="refresh"
        text={"Yenile" + loginInfo.yenileEk}
        onClick={refreshLoginImage}
      />
      <TextBox valueChangeEvent="keyup" value={loginInfo.name} onValueChanged={textValueChanged} />

      <Button
        width={300}
        text={"Giriş" + loginInfo.yenileEk}
        type="normal"
        stylingMode="contained"
        onClick={login}
      />
    </React.Fragment>
  );
};

export default TesvikSgkLogin;
